// extracted by mini-css-extract-plugin
export default {"Checkmark":"checkbox_Checkmark__5wRpj","Checkbox":"checkbox_Checkbox__ordOJ"};